import { useState, useEffect, useContext } from "react";
import blackDeleteIcon from "../../assets/black-delete-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import {
  CaseContext,
  CaseStageContext,
} from "../../dashboard/cases/contexts/CaseContexts";
import { CaseServices } from "../../services/CaseServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";

const TreatmentPlanForm = ({ data }) => {
  const { caseStage, setCaseStage } = useContext(CaseStageContext);
  const { caseDetails } = useContext(CaseStageContext);
  const [enhancementList, setEnhancementList] = useState([]);
  const [treatmentPlanData, setTreatmentPlanData] = useState(
    caseDetails?.caseprocedures || [],
  );

  const getEnhancementList = async () => {
    try {
      const response = await CaseServices.getEnhancementsList(caseDetails?.id);
      const procedureData = response.data.enhancements.map((enhancement) => {
        let data = caseDetails?.caseprocedures?.filter(
          (procedure) => procedure?.id === enhancement?.details?.procedureId,
        );
        if (data && data.length > 0) {
          return {
            ...enhancement,
            procedureCode: data[0].procedureId,
            procedure: data[0].procedure,
            speciality: data[0].speciality,
          };
        } else {
          return {
            ...enhancement,
            procedureCode: "",
            procedure: "",
            speciality: "",
          };
        }
      });
      response.data.enhancements = procedureData;
      setTreatmentPlanData([procedureData[0]]);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    if (!caseDetails) return;
    caseStage?.includes("enhancement")
      ? getEnhancementList()
      : setTreatmentPlanData(caseDetails?.caseprocedures || []);
  }, [caseDetails, caseStage]);

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="pt-[30px]">
        {/* Table Header */}

        <div className="grid grid-cols-[0.48fr_1.44fr_1.20fr_2.04fr_1.20fr_0.87fr_0.96fr] xl:gap-x-[16px] 2xl:gap-x-[30px] 3xl:gap-x-[35px] items-start">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Speciality
          </div>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Procedure Code
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Procedure
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Stratification
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Days/Units
          </div>
          {/* 
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Date & Time
          </div> */}

          {/* <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Amount
          </div> */}

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            ICHI Code
          </div>

          {/* <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Level of care
          </div> */}

          {/* <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div> */}
        </div>

        {/* Table Body */}
        <div className="mt-[30px] flex flex-col gap-y-[34px]">
          {treatmentPlanData?.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-[0.48fr_1.44fr_1.20fr_2.04fr_1.20fr_0.87fr_0.96fr] xl:gap-x-[16px] 2xl:gap-x-[30px] 3xl:gap-x-[35px] items-start"
            >
              {/* Number */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.
              </div>

              {/* Speciality */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.speciality || "--"}
              </div>

              {/* Procedure */}
              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.procedureId || "--"}
              </div>

              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.procedure || "--"}
              </div>

              {/* Stratification */}
              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.stratification || "--"}
              </div>

              {/* Days Units */}
              <div className="pl-[56px] 3xl:pl-[38px] font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.daysUnits || "--"}
              </div>

              {/* Date & Time */}
              {/* <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                  --
                </div> */}

              {/* Amount */}
              {/* <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                  {item?.amount || "--"}
                </div> */}

              {/* ICHI Code */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item?.ichiCode || "--"}
              </div>

              {/* Level of care */}
              {/* <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                  {item?.levelOfCare || "--"}
                </div> */}

              {/* Delete */}
              {/* <button className="flex items-center justify-center bg-transparent border border-none">
                <img src={blackDeleteIcon} alt="delete icon" />
              </button> */}
            </div>
          ))}
        </div>
      </div>
      {/* Save Section */}
      <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        {/* Saved Button */}
        {/* <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
          SAVED
          <img src={whiteRightIcon} alt="white icon" />
        </button> */}

        {/* Edit Button */}
        {/* <button className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent">
          <img src={editIcon} alt="edit icon" />
        </button> */}
      </div>
    </div>
  );
};

export default TreatmentPlanForm;
